// extracted by mini-css-extract-plugin
module.exports = {"logoSpread":"LogoSpread-module--logoSpread--3XAu4","title":"LogoSpread-module--title--1EFuN","logos":"LogoSpread-module--logos--1I__E","logo":"LogoSpread-module--logo--3O6nR"};